export function stringToCurrencyNumber(str) {
  if (!str) return 0
  const num = String(str).replace(/[^0-9.]/g, '')
  if (Number.isNaN(num)) return 0
  return +parseFloat(num).toFixed(2)
}
